<template>
  <div class="home-page container-md">
    <h2>Alert 警告提示</h2>
    <p>警告提示，展现需要关注的信息。</p>

    <h4>何时使用</h4>
    <p>当某个页面需要向用户显示警告的信息时。</p>

    <h4>演示</h4>
    <button class="btn btn-primary btn-large" @click.prevent="create">点击弹出提示</button>
    <button class="btn btn-danger btn-large" @click.prevent="create2">点击弹出错误提示</button>
    <h4 class="mt-4">代码</h4>
    <pre class="language-html">
      <code v-html="highlightedCode"></code>
    </pre>
    <h4>Loader 属性和事件</h4>
    <props-table :props="props"></props-table>
  </div>
</template>

<script>
import Prism from 'prismjs'
import createMessage from '../components/createMessage'
import PropsTable from '../components/PropsTable.vue'
export default {
  data () {
    return {
      isShow: false,
      props: [
        { name: '第一个参数 信息内容', type: 'string', desc: '弹出信息的内容' },
        { name: '第二个参数 信息类型', type: 'string', desc: "可选 'success' | 'error' | 'default'" },
        { name: '第三个参数 信息类型', type: 'number', desc: '显示的时长', default: '2000' }
      ],
      code: `
  <button class="btn btn-primary btn-large" @click.prevent="create">点击弹出提示</button>
  <button class="btn btn-danger btn-large" @click.prevent="create2">点击弹出错误提示</button>
  methods: {
    create () {
      createMessage('这是一条成功信息！', 'success')
    },
    create2 () {
      createMessage('这是一条错误信息！', 'error')
    }
  }`
    }
  },
  computed: {
    highlightedCode () {
      return Prism.highlight(this.code, Prism.languages.html)
    }
  },
  components: {
    PropsTable
  },
  methods: {
    create () {
      createMessage('这是一条成功信息！', 'success')
    },
    create2 () {
      createMessage('这是一条错误信息！', 'error')
    }
  }
}
</script>
